import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import Button from "@mui/material/Button";

export default function ConfirmationDialog({
  open,
  onClose,
  title,
  message,
  onConfirm,
  btn = null,
  confirmLabel,
  cancelLabel,
}) {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      role="alertdialog"
      onClose={handleClose}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ zIndex: 2000 }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ textAlign: "center", fontWeight: 700 }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          component="div"
          sx={{ whiteSpace: "pre-line" }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {btn && (
          <Button onClick={btn.onBtnClick} color="primary" sx={{ fontWeight: 700 }}>
            {btn.btnName}
          </Button>
        )}
        <Button onClick={onClose} sx={{ fontWeight: 700 }}>
          {cancelLabel || "No"}
        </Button>
        <Button onClick={onConfirm} color="primary" sx={{ fontWeight: 700 }}>
          {confirmLabel || "Yes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}